import { useId } from 'react'

type BackgroundDotsProps = {
  /** Fill color for each dot in the pattern. */
  color?: string
  className?: string
  width?: number
  height?: number
}

/** Decorative dotted SVG fill used behind advice cards. */
export function BackgroundDots({
  color = '#FFF0F3',
  className,
  width = 300,
  height = 120
}: BackgroundDotsProps) {
  const reactId = useId().replace(/:/g, '')
  const patternId = `bg-dots-pattern-${reactId}`

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 300 120'
      fill='none'
      className={className}
      aria-hidden='true'
      focusable='false'
    >
      <path d='M0 16C0 7.16344 7.16344 0 16 0H284C292.837 0 300 7.16344 300 16V120H0V16Z' fill={`url(#${patternId})`} />
      <defs>
        <pattern
          id={patternId}
          patternUnits='userSpaceOnUse'
          patternTransform='matrix(6.38 0 0 6.38 0 0)'
          preserveAspectRatio='none'
          viewBox='0 0 63.8 63.8'
          width='1'
          height='1'
        >
          <circle cx='11' cy='11' r='11' fill={color} />
        </pattern>
      </defs>
    </svg>
  )
}
